<template>
  <van-nav-bar
    :fixed="true"
    :placeholder="true"
    :title="title"
    v-if="fleg"
    left-arrow
    @click-left="onClickLeft"
  >
    <template #left>
      <van-icon name="cross" size="20" />
    </template>
  </van-nav-bar>
  <!-- <van-icon name="cross" /> -->
</template>

<script>
import check from "../hook/check";
export default {
  name: "Home",
  props: {
    title: {
      default: "",
      type: String,
    },
  },
  setup() {
    // 点击左侧按钮
    const onClickLeft = () => history.back();
    const { fleg } = check();
    return {
      fleg,
      onClickLeft,
    };
  },
};
</script>
<style lang="less" scoped>
:deep(.van-nav-bar--fixed) {
  z-index: 100;
}
</style>
